module.exports = __webpack_public_path__ + "img/lnk-settings.993819dd.svg";